<script setup lang="ts">

defineProps<{

  subtitle: string

  description?: string

  subtitlePrefix?: string

  subtitleHighlight?: string

  subtitleSuffix?: string

  subtitleAccent?: string

  subtitleBlue?: string

}>()

</script>



<template>

  <section>

    <template v-if="subtitleAccent && subtitleBlue">

      <h2 class="accent-title">{{ subtitleAccent }}</h2>

      <h2 class="blue-title">{{ subtitleBlue }}</h2>

    </template>

    <h2 v-else>

      <template v-if="subtitleHighlight">

        {{ subtitlePrefix }}<span class="accent">{{ subtitleHighlight }}</span>{{ subtitleSuffix }}

      </template>

      <template v-else>{{ subtitle }}</template>

    </h2>

    <h3 v-if="description" class="content-padding">{{ description }}</h3>

  </section>

</template>



<style scoped>

section {

  text-align: center;

}



h2 {

  font-size: 28px;
  line-height: 34.72px;

}



h2 .accent,

.accent-title {

  color: var(--accent-red);

}



.blue-title {

  color: var(--dark-blue);

}



h3 {
  font-size: 16px;
  font-weight: 600;
  line-height: 21.76px;
  margin-top: 1.5rem;
}

</style>

